import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./ThreeBlockSkeletonLoader.scss";

const ThreeBlockSkeletonLoader = ({
  showLeftBlock = true,
  showMiddleBlock = true,
  showRightBlock = true,
  leftBlockWidth = "150px",
  rightBlockWidth = "320px",
  leftBlockItems = 8,
  middleBlockItems = 6,
  rightBlockItems = 4,
  customClasses,
}) => {
  const containerClasses = classNames(classes.container, customClasses);

  const renderLeftBlock = () => (
    <div className={classes.leftBlock} style={{ width: leftBlockWidth }}>
      <div className={classes.leftBlockHeader}>
        <SkeletonLoader width="60%" height="20px" variant="rounded" />
      </div>
      <div className={classes.leftBlockContent}>
        {Array.from({ length: leftBlockItems }, (_, index) => (
          <div key={index} className={classes.leftBlockItem}>
            <SkeletonLoader width="100%" height="32px" variant="rounded" />
          </div>
        ))}
      </div>
    </div>
  );

  const renderMiddleBlock = () => (
    <div className={classes.middleBlock}>
      <div className={classes.middleBlockContent}>
        {Array.from({ length: middleBlockItems }, (_, index) => (
          <div key={index} className={classes.middleBlockItem}>
            <div className={classes.itemRow}>
              <SkeletonLoader width="16px" height="16px" variant="rounded" />
              <SkeletonLoader width="70%" height="16px" variant="rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderRightBlock = () => (
    <div className={classes.rightBlock} style={{ width: rightBlockWidth }}>
      <div className={classes.rightBlockContent}>
        {Array.from({ length: rightBlockItems }, (_, index) => (
          <div key={index} className={classes.rightBlockItem}>
            <div className={classes.itemRow}>
              <SkeletonLoader width="16px" height="16px" variant="rounded" />
              <div className={classes.itemDetails}>
                <SkeletonLoader width="80%" height="14px" variant="rounded" />
                <SkeletonLoader width="60%" height="12px" variant="rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={containerClasses}>
      {showLeftBlock && renderLeftBlock()}
      {showMiddleBlock && renderMiddleBlock()}
      {showRightBlock && renderRightBlock()}
    </div>
  );
};

ThreeBlockSkeletonLoader.propTypes = {
  showLeftBlock: PropTypes.bool,
  showMiddleBlock: PropTypes.bool,
  showRightBlock: PropTypes.bool,
  leftBlockWidth: PropTypes.string,
  rightBlockWidth: PropTypes.string,
  leftBlockItems: PropTypes.number,
  middleBlockItems: PropTypes.number,
  rightBlockItems: PropTypes.number,
  customClasses: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ThreeBlockSkeletonLoader;
